import { __rest } from "tslib";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b509171"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "StoryMap__Backdrop absolute inset-0 bg-true-black/60" }, null, -1));
const _hoisted_2 = { class: "MapContainer flex-none relative flex lg:justify-center lg:items-center min-w-full text-black" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "Map Map--placeholder flex-none" }, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "MapContainer__Background absolute" }, null, -1));
const _hoisted_5 = {
    key: 0,
    class: "size-full max-w-none",
    src: "/assets/images/maps/map-germany-1.png",
    srcset: "/assets/images/maps/map-germany-1.png 1x, /assets/images/maps/map-germany-1@2x.png 2x",
    alt: "",
    width: "915",
    height: "801",
    decoding: "async"
};
const _hoisted_6 = {
    key: 1,
    class: "size-full max-w-none",
    src: "/assets/images/maps/map-germany-2.png",
    srcset: "/assets/images/maps/map-germany-2.png 1x, /assets/images/maps/map-germany-2@2x.png 2x",
    alt: "",
    width: "915",
    height: "801",
    decoding: "async"
};
const _hoisted_7 = {
    key: 2,
    class: "size-full max-w-none",
    src: "/assets/images/maps/map-europe.png",
    srcset: "/assets/images/maps/map-europe.png 1x, /assets/images/maps/map-europe@2x.png 2x",
    alt: "",
    width: "979",
    height: "641",
    decoding: "async"
};
const _hoisted_8 = { class: "Map flex-none" };
const _hoisted_9 = { class: "relative size-full isolate" };
const _hoisted_10 = { class: "StoryMap__UI relative h-full pointer-events-none" };
const _hoisted_11 = { class: "absolute top-0 left-0 flex flex-col items-start gap-16" };
const _hoisted_12 = { class: "hidden lg:block max-w-cols-3" };
import { ref, computed, watch, defineAsyncComponent, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import { onKeyDown } from "@vueuse/core";
import { smoothOriginChange } from "@/utils/gsap.helpers";
import { setFPS } from "@/utils/frameToTime";
import { unique } from "@/utils/array.utils";
import Viewport from "@/store/modules/Viewport";
import useGSAP from "@/composables/useGSAP";
import useLocalTransition from "@/composables/useLocalTransition";
import AppService from "@/services/AppService";
import { getCurrentContent, muxManifestUrl, HotSpotMediaType } from "@/config/content";
import { getMapConfig } from "@/config/maps";
import { MEDIA_CLOSING_DURATION } from "@/config/constants";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoryMap',
    props: {
        show: { type: Boolean }
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        var _a;
        _useCssVars(_ctx => ({
            "98e54ce4": (_unref(mapDimensions).width),
            "b7624342": (_unref(mapDimensions).height),
            "4465d170": (mapCenter.x),
            "4465d16e": (mapCenter.y)
        }));
        const props = __props;
        const emit = __emit;
        const LazyMapGermany = defineAsyncComponent(() => import("./assets/MapGermany.vue"));
        const LazyMapEurope = defineAsyncComponent(() => import("./assets/MapEurope.vue"));
        const { t } = useI18n();
        const show = useLocalTransition(() => props.show);
        const { content, type: mapType } = getCurrentContent()[AppService.getStoryContext().currHotspotId];
        const mapId = mapType === HotSpotMediaType.MAP_EUROPE ? "europe" : "germany";
        const mapConfig = getMapConfig(mapId);
        const { dimensions: mapDimensions } = mapConfig;
        const mapCenter = {
            x: (((_a = mapConfig.center) === null || _a === void 0 ? void 0 : _a.x) || 0.5 * mapDimensions.width) / mapDimensions.width,
            y: 0.5
        };
        const hotspots = computed(() => content.hotspots.map(({ id, image, video, text }) => {
            const _a = mapConfig.hotspots.find((hotspot) => hotspot.id === id), { areaId = id } = _a, hotspot = __rest(_a, ["areaId"]);
            if (!hotspot)
                return;
            return Object.assign(Object.assign({ id, data: {
                    title: t(text.titlekey),
                    description: t(text.textkey),
                    image: image ? Object.assign(Object.assign({}, image), { src: [`${Viewport.isMobile ? image.src.replace("/assets/content/generated/", "/assets/content/generated-mobile/") : image.src}.avif`, `${image.src}.webp`] }) : undefined,
                    video: video ? Object.assign(Object.assign({}, video), { src: (video === null || video === void 0 ? void 0 : video.src) ? muxManifestUrl(video.src, Viewport.isMobile ? "?max_resolution=720p" : "") : "", poster: `${Viewport.isMobile ? image.src.replace("/assets/content/generated/", "/assets/content/generated-mobile/") : image.src}.avif` }) : undefined,
                    date: t(content.introText.datekey),
                    place: t(text.placekey),
                    caption: t(text.captionkey),
                } }, hotspot), { areaId });
        }).filter(Boolean));
        const mapAreas = computed(() => unique(hotspots.value.map(({ areaId }) => areaId)));
        const gsap = useGSAP();
        const frames = setFPS(60);
        const { isDesktop, isMobile } = toRefs(Viewport);
        const hoveredHotspotIndex = ref(-1);
        const setHoveredHotspotIndex = (index) => hoveredHotspotIndex.value = index;
        const clearHoveredHotspot = () => setHoveredHotspotIndex(-1);
        const selectedHotspotIndex = ref(-1);
        const setSelectedHotspotIndex = (index) => selectedHotspotIndex.value = index;
        const clearSelectedHotspot = () => setSelectedHotspotIndex(-1);
        const wrapHotspotIndex = gsap.utils.wrap(0, hotspots.value.length);
        const hoveredHotspot = computed(() => hotspots.value[hoveredHotspotIndex.value]);
        const selectedHotspot = computed(() => hotspots.value[selectedHotspotIndex.value]);
        const hasSelectedHotspot = computed(() => selectedHotspotIndex.value !== -1);
        function prevHotspot() {
            const prevIndex = wrapHotspotIndex(selectedHotspotIndex.value - 1);
            setSelectedHotspotIndex(prevIndex);
        }
        function nextHotspot() {
            const nextIndex = wrapHotspotIndex(selectedHotspotIndex.value + 1);
            setSelectedHotspotIndex(nextIndex);
        }
        function close() {
            emit("close");
        }
        const root = ref(null);
        const mapScroller = ref(null);
        const mapController = ref(null);
        const hotspotsController = ref(null);
        const hotspotEls = ref([]);
        const ZOOM_MIN = ref(1);
        const ZOOM_MAX = computed(() => isMobile.value ? 1.85 : 3);
        watch(selectedHotspotIndex, (index, prevIndex) => {
            const { windowWidth: vw, windowHeight: vh } = Viewport;
            const $ = gsap.utils.selector(root.value);
            const transition = index === -1 ? "zoomout" : prevIndex === -1 ? "zoomin" : "pan";
            const scrollLeft = mapScroller.value.scrollLeft;
            const hotspotsPositions = (() => {
                // reset scroll position
                mapScroller.value.scrollLeft = 0;
                // reset controller position
                const getControllerProp = gsap.getProperty(hotspotsController.value);
                const xFrom = getControllerProp("x");
                const yFrom = getControllerProp("y");
                gsap.set(hotspotsController.value, { x: 0, y: 0 });
                const positions = hotspotEls.value.map((el) => {
                    const { x, y } = el.getBoundingClientRect();
                    return { x, y };
                });
                // restore scroll position
                mapScroller.value.scrollLeft = scrollLeft;
                // restore controller previous position
                gsap.set(hotspotsController.value, { x: xFrom, y: yFrom });
                return positions;
            })();
            const { x: cx, y: cy } = hotspotsPositions[transition === "zoomout" ? prevIndex : index];
            const zoomVars = { cx, cy, scale: transition === "zoomout" ? ZOOM_MIN.value : ZOOM_MAX.value };
            const moveVars = { x: 0, y: 0 };
            if (transition !== "zoomout") {
                moveVars.x = (isMobile.value ? 0.5 * vw : 0.75 * vw) - cx + scrollLeft;
                moveVars.y = (isMobile.value ? 0.25 * vh : 0.5 * vh) - cy;
            }
            const tl = gsap.timeline({
                defaults: {
                    duration: frames(60),
                    ease: "ease.out"
                }
            });
            tl.to([mapController.value, hotspotsController.value], moveVars, 0);
            tl.to(mapController.value, { scale: zoomVars.scale }, 0);
            // highlight current map area
            if (isDesktop.value) {
                hotspots.value.forEach(({ areaId }) => {
                    var _a;
                    const isCurrent = areaId === ((_a = selectedHotspot.value) === null || _a === void 0 ? void 0 : _a.areaId);
                    tl.to($(`#MapAreaDropShadow-${areaId} > feOffset`), { attr: { dy: isCurrent ? -15 / zoomVars.scale : 0 } }, 0);
                    tl.set($(`#MapPatternDiagonalHatch-${areaId} > rect`), { opacity: isCurrent ? 1 : 0 }, isCurrent ? "<" : ">");
                });
            }
            if (transition !== "pan") {
                smoothOriginChange(mapController.value, `${zoomVars.cx}px ${zoomVars.cy}px 0px`);
                tl.to(hotspotEls.value, {
                    x: transition === "zoomout" ? 0 : (i) => {
                        const dx = hotspotsPositions[i].x - cx;
                        return dx * zoomVars.scale - dx;
                    },
                    y: transition === "zoomout" ? 0 : (i) => {
                        const dy = hotspotsPositions[i].y - cy;
                        return dy * zoomVars.scale - dy;
                    }
                }, 0);
            }
            if (transition === "zoomout" && isMobile.value) {
                tl.to(mapScroller.value, {
                    scrollTo: {
                        x: Math.max(0, zoomVars.cx - 0.5 * vw)
                    }
                }, 0);
            }
            setHoveredHotspotIndex(index);
        });
        function onEnter(el, onComplete) {
            const $ = gsap.utils.selector(el);
            const tl = gsap.timeline({
                onComplete,
                defaults: {
                    ease: "ease.out"
                }
            })
                .add("content", frames(25))
                .add("map", frames(60));
            tl
                .from($(".StoryMap__Backdrop"), {
                opacity: 0,
                duration: frames(40)
            }, 0)
                .from($(".MapScroller"), {
                autoAlpha: 0,
                duration: frames(35)
            }, "content")
                .from($(".StoryMap__UI"), {
                autoAlpha: 0,
                duration: frames(30)
            }, "content")
                .to($(".MapContainer__Background"), {
                keyframes: {
                    "0%": { opacity: 0 },
                    "8.571429%": { opacity: 0.5 },
                    "25.714286%": { opacity: 0.5 },
                    "34.285714%": { opacity: 0 },
                    "42.857143%": { opacity: 0 },
                    "51.428571%": { opacity: 0.75 },
                    "60%": { opacity: 0.75 },
                    "68.571429%": { opacity: 0 },
                    "100%": { opacity: 1, ease: "ease.out" },
                    easeEach: "none"
                },
                duration: frames(35)
            }, "content");
            tl.add(() => {
                const [background] = $(".StoryMap__Background");
                gsap.set(background, { x: 0.75 * Viewport.windowWidth, y: Viewport.windowHeight, rotation: -40, transformOrigin: "25% 0%" });
                smoothOriginChange(background, "50% 50%");
                return gsap.to(background, {
                    x: 0,
                    y: 0,
                    rotation: 0,
                    duration: frames(40),
                    ease: "ease.out"
                });
            }, 0);
        }
        function onLeave(el, onComplete) {
            const tl = gsap.timeline({ onComplete });
            tl.to(el, {
                opacity: 0,
                duration: MEDIA_CLOSING_DURATION / 1000,
                ease: "ease.out"
            });
        }
        onKeyDown(["Escape"], () => {
            if (hasSelectedHotspot.value)
                return;
            close();
        });
        return (_ctx, _cache) => {
            const _component_UIDogEared = _resolveComponent("UIDogEared");
            const _component_UIMaskReveal = _resolveComponent("UIMaskReveal");
            const _component_UIMapHotspot = _resolveComponent("UIMapHotspot");
            const _component_UIBtnClose = _resolveComponent("UIBtnClose");
            const _component_StoryMinimap = _resolveComponent("StoryMinimap");
            const _component_StoryMapPanel = _resolveComponent("StoryMapPanel");
            return (_openBlock(), _createBlock(_Transition, {
                css: false,
                onEnter: onEnter,
                onLeave: onLeave
            }, {
                default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", {
                        ref_key: "root",
                        ref: root,
                        class: "StoryMap absolute inset-0 z-1 p-20 lg:p-24 overflow-hidden text-white pointer-events-auto"
                    }, [
                        _hoisted_1,
                        _createVNode(_component_UIDogEared, {
                            class: "StoryMap__Background !absolute inset-0",
                            width: _unref(isDesktop) ? '27%' : '45%',
                            height: "68%",
                            delay: _unref(frames)(10),
                            theme: "dark"
                        }, null, 8, ["width", "delay"]),
                        _createElementVNode("div", {
                            ref_key: "mapScroller",
                            ref: mapScroller,
                            class: _normalizeClass(["MapScroller absolute inset-0 flex overflow-x-auto overflow-y-hidden lg:overflow-hidden scrollbar-none overscroll-contain", `MapScroller--${_unref(mapId)}`])
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _hoisted_3,
                                _hoisted_4,
                                _createElementVNode("div", {
                                    ref_key: "mapController",
                                    ref: mapController,
                                    class: "MapController absolute inset-0 flex lg:justify-center lg:items-center"
                                }, [
                                    _createVNode(_component_UIMaskReveal, {
                                        class: "Map flex-none relative",
                                        delay: _unref(frames)(45)
                                    }, {
                                        default: _withCtx(() => [
                                            (_unref(isMobile))
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (_unref(mapType) === _unref(HotSpotMediaType).MAP)
                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                                        : (_unref(mapType) === _unref(HotSpotMediaType).MAP_1)
                                                            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                                            : (_unref(mapType) === _unref(HotSpotMediaType).MAP_EUROPE)
                                                                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                                                                : _createCommentVNode("", true)
                                                ], 64))
                                                : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(mapId) === 'europe' ? _unref(LazyMapEurope) : _unref(LazyMapGermany)), _mergeProps({
                                                    key: 1,
                                                    class: "size-full",
                                                    areas: mapAreas.value
                                                }, _unref(mapDimensions)), null, 16, ["areas"]))
                                        ]),
                                        _: 1
                                    }, 8, ["delay"])
                                ], 512),
                                _createElementVNode("div", {
                                    ref_key: "hotspotsController",
                                    ref: hotspotsController,
                                    class: "HotspotsController absolute inset-0 flex lg:justify-center lg:items-center"
                                }, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotspots.value, ({ id, data, coordinates, placement }, i) => {
                                                var _a;
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: id,
                                                    ref_for: true,
                                                    ref: (el) => (hotspotEls.value[i] = el),
                                                    class: _normalizeClass(["Hotspot absolute flex justify-center items-center size-0 *:flex-none hover:z-2", { 'z-2': selectedHotspotIndex.value === i }]),
                                                    style: _normalizeStyle({ '--x': coordinates.x, '--y': coordinates.y })
                                                }, [
                                                    _createVNode(_component_UIMapHotspot, {
                                                        thumbnail: data.image,
                                                        placement: placement,
                                                        "hide-label": data.place === ((_a = hoveredHotspot.value) === null || _a === void 0 ? void 0 : _a.data.place),
                                                        selected: selectedHotspotIndex.value === i,
                                                        delay: _unref(frames)(60 + i * 6),
                                                        onMouseenter: ($event) => (setHoveredHotspotIndex(i)),
                                                        onMouseleave: _cache[0] || (_cache[0] = () => !hasSelectedHotspot.value && clearHoveredHotspot()),
                                                        onClick: ($event) => (setSelectedHotspotIndex(i))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(data.place), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["thumbnail", "placement", "hide-label", "selected", "delay", "onMouseenter", "onClick"])
                                                ], 6));
                                            }), 128))
                                        ])
                                    ])
                                ], 512)
                            ])
                        ], 2),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createVNode(_component_UIMaskReveal, {
                                    as: "h1",
                                    class: "Title text-mobile-h3 lg:text-desktop-h3 whitespace-pre-line text-balance text-accent",
                                    delay: _unref(frames)(25)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_unref(content).introText.titlekey)), 1)
                                    ]),
                                    _: 1
                                }, 8, ["delay"]), [
                                    [_vShow, !hasSelectedHotspot.value]
                                ]),
                                _createVNode(_Transition, {
                                    name: "fade",
                                    appear: ""
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("div", _hoisted_12, [
                                            _createVNode(_component_UIMaskReveal, {
                                                as: "p",
                                                class: "text-desktop-cap text-pretty whitespace-pre-line",
                                                delay: _unref(frames)(50)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(content).introText.textkey)), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["delay"])
                                        ], 512), [
                                            [_vShow, !hasSelectedHotspot.value]
                                        ])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createVNode(_component_UIBtnClose, {
                                class: "!absolute top-0 right-0 pointer-events-auto",
                                onClick: close
                            }),
                            (_unref(isDesktop) && _unref(mapId) === 'germany')
                                ? (_openBlock(), _createBlock(_Transition, {
                                    key: 0,
                                    name: "fade",
                                    appear: ""
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createVNode(_component_StoryMinimap, { class: "!absolute bottom-0 left-0" }, null, 512), [
                                            [_vShow, !hasSelectedHotspot.value]
                                        ])
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _withDirectives(_createVNode(_component_UIMaskReveal, {
                                class: "!absolute bottom-0 right-0 hidden lg:block text-desktop-h2 text-accent",
                                delay: _unref(frames)(35)
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(content).introText.datekey)), 1)
                                ]),
                                _: 1
                            }, 8, ["delay"]), [
                                [_vShow, !hasSelectedHotspot.value]
                            ])
                        ]),
                        (selectedHotspot.value)
                            ? (_openBlock(), _createBlock(_component_StoryMapPanel, _mergeProps({
                                key: 0,
                                class: "z-1"
                            }, selectedHotspot.value.data, {
                                onPrev: prevHotspot,
                                onNext: nextHotspot,
                                onClose: clearSelectedHotspot
                            }), null, 16))
                            : _createCommentVNode("", true)
                    ], 512), [
                        [_vShow, _unref(show)]
                    ])
                ]),
                _: 1
            }));
        };
    }
});
